import {ValueOf} from 'shared/web';

import {NOTIFICATIONS_EVENTS} from '../utils/events';

export type NotificationEvents = ValueOf<typeof NOTIFICATIONS_EVENTS>;
